// src/hooks/useYoutube.js - WITHOUT AUTH
import { useState, useEffect, useCallback } from 'react';
import youtubeService from './Youtubeservice';

export const useYouTube = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [initialized, setInitialized] = useState(false);

  // Initialize YouTube API
  useEffect(() => {
    const initYouTube = async () => {
      try {
        setLoading(true);
        await youtubeService.loadYouTubeAPI();
        setInitialized(true);
        setError(null);
      } catch (err) {
        setError(err.message || 'Failed to initialize YouTube API');
        console.error('Initialization error:', err);
      } finally {
        setLoading(false);
      }
    };

    initYouTube();
  }, []);

  // Search songs
  const searchSongs = useCallback(async (query, maxResults = 20) => {
    try {
      setLoading(true);
      setError(null);
      
      const results = await youtubeService.searchSongs(query, maxResults);
      return results;
      
    } catch (err) {
      setError(err.message || 'Failed to search songs');
      console.error('Search error:', err);
      return [];
    } finally {
      setLoading(false);
    }
  }, []);

  // Get trending music
  const getTrendingMusic = useCallback(async (maxResults = 20) => {
    try {
      setLoading(true);
      setError(null);
      
      const results = await youtubeService.getTrendingMusic(maxResults);
      return results;
      
    } catch (err) {
      setError(err.message || 'Failed to get trending music');
      console.error('Trending error:', err);
      return [];
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    loading,
    error,
    initialized,
    searchSongs,
    getTrendingMusic
  };
};